module.exports = __webpack_public_path__ + "img/Screen Shot 2020-05-07 at 6.31.48 PM.9162c7e4.png";